import * as types from '@/modules/Cashbox/store/mutation-types'
import cashApi from '@/modules/Cashbox/api/'

export const defaultModuleName = 'cash'

export default {
  namespaced: true,
  state: {
    cashList: [],
    cashRegister: '',
    isLoading:true,
    cashAmount:'',

  },
  getters: {
    cashRegister (state) {
      return state.cashRegister
    },
    cashList (state) {
      return state.cashList
    },
    isLoading (state) {
      return state.isLoading
    },
    cashAmount (state) {
      return state.cashAmount
    },


  },
  mutations: {
    [types.IS_LOADING]: (state, status) => {
      return state.isLoading = status
    },
    [types.UPDATE_CASH_REGISTERS]: (state, payload) => {
      return state.cashList = payload
    },
    [types.UPDATE_CASH_REGISTER_BY_ID]: (state, payload) => {
      return state.cashRegister = payload
    }, [types.UPDATE_CASH_AMOUNT]: (state, payload) => {

      return state.cashAmount = payload
    }

  },
  actions: {
    async getCashList ({commit}, payload) {
      commit(types.IS_LOADING, true)
      try {
        let {org_id, params} = payload
        let resp = await cashApi.getCashRegisters(org_id, params)
        commit(types.UPDATE_CASH_REGISTERS, resp.data)
        commit(types.UPDATE_CASH_AMOUNT, resp.headers['x-total-count'])
      } catch (e) {
        this.$message.error('Ошибка при получении данных о кассах')
      }
      finally {
        commit(types.IS_LOADING, false)
      }
    },
    async getCashRegisterById ({commit}, payload) {
      commit(types.IS_LOADING, true)
      try {
        let {org_id, kkt_id} = payload
        let resp = await cashApi.getCashRegisterById(org_id, kkt_id)
        commit(types.UPDATE_CASH_REGISTER_BY_ID, resp.data)
      } catch (e) {
        this.$message.error('Ошибка при получении данных о кассе')
      }
      finally {
        commit(types.IS_LOADING, false)
      }
    }
  }
}
